import { CalendarDays, Mail, MapPin, Phone } from "lucide-react";
import { META } from "@/content/meta";
import { SITE } from "@/content/site";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Reveal } from "@/components/motion/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { BookCallButton, PhoneValue, PlaceholderTag } from "@/components/site/Bits";
import { ContactForm } from "@/components/forms/ContactForm";

const InfoCard = ({ icon: Icon, title, children, testId }) => (
  <div className="rounded-2xl border border-white/[0.08] bg-[#0E1015] p-6" data-testid={testId}>
    <div className="flex items-center gap-3">
      <span className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 bg-white/[0.03]">
        <Icon className="h-4 w-4 text-[#2F6BFF]" aria-hidden="true" />
      </span>
      <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">{title}</h2>
    </div>
    <div className="mt-4 text-white/90">{children}</div>
  </div>
);

export default function Contact() {
  usePageMeta(META.contact);
  return (
    <PageHero
      eyebrow="Contact"
      lines={["Let's talk about", "your website."]}
      copy="Tell us a little about your business and what you need. A founder will get back to you by email or phone."
      testId="contact-hero"
    >
      <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:gap-10">
        <Reveal delay={0.2} className="lg:col-span-7">
          <div
            id="contact-form"
            className="rounded-2xl border border-white/10 bg-[#0E1015]/80 p-6 shadow-[0_40px_100px_-40px_rgba(37,99,235,0.45)] backdrop-blur-xl sm:p-10"
          >
            <ContactForm />
          </div>
        </Reveal>
        <Reveal as="aside" delay={0.3} className="space-y-4 lg:col-span-5" aria-label="Other ways to reach us">
          <InfoCard icon={Mail} title="Email" testId="contact-email-card">
            <a href={`mailto:${SITE.email}`} className="text-lg font-medium hover:text-[#2DD4D4]" data-testid="contact-email-link">
              {SITE.email}
            </a>
          </InfoCard>
          <InfoCard icon={Phone} title="Phone" testId="contact-phone-card">
            <PhoneValue testId="contact-phone" className="text-lg font-medium" />
          </InfoCard>
          <InfoCard icon={CalendarDays} title="Book a call" testId="contact-book-call-card">
            <p className="text-[15px] text-[#A1A1AA]">Prefer to talk? Grab 15 minutes with a founder.</p>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <BookCallButton testId="contact-book-call-button" />
              {!SITE.bookCallUrl && <PlaceholderTag testId="book-call-placeholder">Booking link placeholder</PlaceholderTag>}
            </div>
          </InfoCard>
          <InfoCard icon={MapPin} title="Service area" testId="contact-service-area-card">
            <p className="text-lg font-medium">{SITE.serviceArea}</p>
          </InfoCard>
        </Reveal>
      </div>
    </PageHero>
  );
}
